<template>
  <a  href="#"  @click.prevent="openDonationModal"  class="hidden lg:block rounded-full bg-pink hover:bg-pink-600 border-2 border-transparent text-white block py-3 lg:py-3 lg:px-12 font-medium uppercase text-center text-sm focus:outline-none  focus:ring-pink-200">Donate</a>
  <make-donation-widget v-if="open_donation" :campaign-id="campaignId" :pledge-id="pledgeId" :campaign="campaign" :key="`header_don_`+campaignId"></make-donation-widget>
</template>

<script>
  import Modal from '../ui/Modal'
  import MakeDonationWidget from '../make-donation/MakeDonationWidget'
  import MakePledgeWidget from '../campaigns/campaign-page/pledge-drives/MakePledgeWidget'


  export default {
    name: 'MyDonateButtonHeader',

    components: { MakePledgeWidget, MakeDonationWidget, Modal },

    props: {
      campaignId: {
        required: true,
        type: String,
      },

      campaign: {
        required: false,
      },

      pledgeId: {
        required: false,
        default: '',
      },
    },

    created() {
      this.emitter.on('pledge-modal-close',  () => {
        this.open_pledge = false
      });
      this.emitter.on('donation-modal-close',  () => {
        this.open_donation = false
      });
    },

    data() {
      return {
        isOpen: false,
        donationModalIsOpen: false,
        isSaving: false,
        pledgeForm: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          amount: null,
          amount_limit: null,
          pledge_drive_id: (this.campaign && this.campaign.pledge_drive) ? this.campaign.pledge_drive.id : '',
          campaign_id: this.campaign.id,
        },
        open_pledge: false,
        open_donation: false
      }
    },

    methods: {
      openDonationModal() {
        this.emitter.emit('open-donation-modal');
      },
      openMakePledgeModal() {
        this.emitter.emit('open-pledge-modal');
      },
    },
  }
</script>

<style scoped>

</style>
